
import * as actions from 'actions';
import emojisMaker from 'reducersMakers/emojisMaker';

export default emojisMaker({
  showType: actions.CHAT_EMOJIS_SHOW,
  closeType: actions.CHAT_EMOJIS_HIDE
});



/** WEBPACK FOOTER **
 ** ./src/members/state/chat/emojis/chatMessage/reducer.js
 **/